import React, { useState } from 'react'
import { Container,Row,Col } from 'react-bootstrap'
import AdminSideBar from '../../components/adminSide/AdminSideBar'
import AdminHeader from '../../components/adminHeader/AdminHeader'
// import CircleTable from '../../components/circletable/CircleTable'

export default function Adminn() {


  return (
   
   <Container fluid>
<Row>
<Col xs={2}>
  <AdminSideBar/>
</Col>
<Col xs={10}>
  <AdminHeader/>
  <Row>
    <Col></Col>
    {/* <Col md={10}><CircleTable/> </Col> */}
    <Col></Col>
  </Row>
</Col>


</Row>

    </Container>

  )
}
